import React from 'react';

interface NoDataInvoiceIconProps {
  className?: string;
  size?: number;
}

const NoDataInvoiceIcon: React.FC<NoDataInvoiceIconProps> = ({ 
  className = "w-24 h-24 text-gray-300", 
  size = 24 
}) => {
  return (
    <div className={className}>
      <svg
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="w-full h-full"
      >
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
        <polyline points="14,2 14,8 20,8" />
        <line x1="16" y1="13" x2="8" y2="13" />
        <line x1="16" y1="17" x2="8" y2="17" />
        <polyline points="10,9 9,9 8,9" />
      </svg>
    </div>
  );
};

export default NoDataInvoiceIcon;
